module.exports = __webpack_public_path__ + "img/noLimit.c866ab3.svg";